import styled, { css } from 'styled-components';
import { lighten } from 'polished';

import 'antd/lib/spin/style/index.css';

export const BreadcumbsContainer = styled.div`
  margin: 0 auto 5px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;
export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: space-between;

  div.headerInline {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    margin-top: 4px;
    color: #235f6e;
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
`;

export const BoxList = styled.div`
  width: 100%;
  min-height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-top: 15px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #235f6e;

  div.nomeUsuario {
    min-height: 70px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    letter-spacing: 0px;
    text-align: left;
    color: #235f6e;
  }

  div.email {
    min-height: 70px;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.46px;
    color: #235f6e;
  }

  div.data {
    min-height: 70px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: center;
    color: #235f6e;
  }

  div.horaLogin {
    min-height: 70px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #235f6e;
  }

  div.buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    button {
      color: #fff;
      border: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 34px;
      border-radius: 3.5px;
      background-color: #74a50a;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: normal;
      text-align: right;
      color: #ffffff;
      a {
        color: #fff;
        margin: 0;
        padding: 0;
        display: block;
        padding: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

      svg,
      img {
        margin-right: 5px;
      }
      &:first-child {
        width: 114px;
        &:hover {
          background-color: ${lighten(0.1, '#74a50a')};
        }
      }
      &:nth-child(2) {
        margin-left: 20px;
        width: 157px;
        background-color: #398ca1;
        &:hover {
          background-color: ${lighten(0.1, '#398ca1')};
        }
      }
      &:last-child {
        width: 77px;
        background-color: #235f6e;

        margin-left: 20px;
        &:hover {
          background-color: ${lighten(0.1, '#235f6e')};
        }
      }
    }
  }
`;

export const BoxListGestor = styled.div`
  width: '100%';
  min-height: 80px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #235f6e;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const ButtonList = styled.div`
  width: 21px;
  height: 21px;
  border-radius: 3px;
  border: solid 0.5px
    ${props =>
      props.listOperacao === props.idInstituicao ? '#999999 ' : '#d8d8d8'};
  background-color: ${props =>
    props.listOperacao === props.idInstituicao ? '#999999' : '#FFF'};
  margin-right: 20px;
  svg {
    color: ${props =>
      props.listOperacao === props.idInstituicao ? '#FFF' : '#999999'};
  }
`;

export const BoxListHideBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid red; */
  > div + div {
    border-top: solid 1px rgba(35, 95, 110, 0.1);
  }
  margin-bottom: -10px;
`;

export const BoxListHide = styled.div`
  background-color: #f7f7f7;
  padding: 10px 30px;
  /* border: 1px solid blue; */
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      /* min-width: 26px; */
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
        &:hover {
          color: #fff;
        }
      }
    }
  }
`;

export const SearchContainer = styled.div`
  ${() => css`
    margin-left: 20px;
    form {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    div.ant-select {
      margin-right: 8px;

      span {
        font-size: 12px;
      }
    }

    /*
    *
    * ANT SELECT
    *
    */

    .ant-select-selection:hover {
      border: 1px solid #74a50a;
    }

    .ant-select-focused .ant-select-selection,
    .ant-select-selection:focus,
    .ant-select-selection:active {
      border-color: #74a50a;
      border-right-width: 1px !important;
      outline: 0;
      -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    .ant-select-open .ant-select-selection {
      border-color: #74a50a;
    }

    .ant-select-dropdown.ant-select-dropdown--multiple
      .ant-select-dropdown-menu-item-selected
      .ant-select-selected-icon,
    .ant-select-dropdown.ant-select-dropdown--multiple
      .ant-select-dropdown-menu-item-selected:hover
      .ant-select-selected-icon {
      display: inline-block;
      color: #74a50a;
    }

    /*
    *
    * ANT SELECT
    *
    */

    label {
      width: 244.5px;
      height: 33.4px;
      padding: 0 10px;
      border-radius: 3px;
      box-shadow: inset 0px 1px 0px 0px #c7c7c794;
      border: solid 1px #c7c7c794;
      background: #ffffff;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    input {
      border: 0;
      color: #74a50a;
      margin: 0 0 0 5px;
      &::placeholder {
        color: #282828;
      }
    }
    button {
      margin-left: 4px;
    }
    button.limparBusca {
      width: 90px;
      height: 34px;
      border-radius: 3.5px;
      background-color: #235f6e;
      border: none;
      color: #ffffff;
      margin-left: 10px;
    }
  `}
`;

export const BoxAsyncSelect = styled.div`
  width: 220px;

  input[type='text'] {
    box-shadow: inset 0px 1px 0px 0px #fff;
  }

  span {
    font-size: 4px;
  }
`;

export const BoxAuth = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 0px 10px 10px 10px;
  margin: 0 auto;
  border: solid 0.8px #d9d9d9;
  background-color: #f7f7f7;

  .ant-table-tbody {
    color: #235f6e;
  }

  div.BoxAuthContainer {
    margin: 20px auto;
    div.title {
      margin-bottom: 33px;
      h2 {
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: 0.01px;
        text-align: center;
        color: #282828;
        span {
          font-weight: bold;
          color: #74a50a;
        }
      }
    }

    div.selectMonth {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 60px;

      .ant-select-selection {
        background-color: #ebeaea;
      }

      .ant-select-selection--single {
        height: 38px;
      }

      .ant-select-selection__rendered {
        line-height: 38px;
      }
    }

    /*
    *
    *CUSTOM CSS TABLE
    *
    */

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
      background: #f7f7f7 !important;
    }

    .ant-table-thead
      > tr
      > th
      .ant-table-column-sorter
      .ant-table-column-sorter-inner
      .ant-table-column-sorter-up.on,
    .ant-table-thead
      > tr
      > th
      .ant-table-column-sorter
      .ant-table-column-sorter-inner
      .ant-table-column-sorter-down.on {
      color: #74a50a;
    }

    .ant-table-thead {
      border: 1px solid red;
    }

    /*


    ant-table-column-has-actions ant-table-column-has-sorters ant-table-column-sort ant-table-row-cell-break-word


    */

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-sorters {
      cursor: pointer;
      background: #f7f7f7 !important;
    }

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
      cursor: pointer;
      background: #f7f7f7 !important;
    }

    .ant-table-thead
      > tr
      > th
      .ant-table-header-column
      .ant-table-column-sorters::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: transparent;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      content: '';
    }
  }
  hr {
    opacity: 0.1;
    display: block;
    margin: 60px 0;
  }

  div.ant-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    h2 {
      font-size: 20px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.22;
      letter-spacing: 0.01px;
      text-align: center;
      color: #282828;
      margin-bottom: 25px;
    }
  }

  div.alertMessage {
    width: 365px;
    margin: 40px auto 0 auto;

    .ant-alert-success {
      background-color: rgba(116, 165, 10, 0.16);
      border: 1px solid #a4c951;
      .ant-alert-message {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.1;
        letter-spacing: 0.09px;
        text-align: left;
        color: #74a50a;
      }
    }
  }

  .colInsercao {
    border-right: 1px solid #707070;
  }

  div.boxSpin {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
  }

  /*
  TABELA / GRID
*/
  .ant-table-tbody tr > td:first-child {
    white-space: nowrap;
  }
  .ant-table-thead * {
    background-color: #f7f7f7;

    span.ant-table-column-title {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: 0.01px;
      color: #727272;
      text-align: center;
    }
  }
  .ant-table-row {
    background-color: #fff;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #e8e8e8;
    -webkit-transition: all 0.3s, border 0s;
    transition: all 0.3s, border 0s;
    margin-bottom: 7px;
  }
`;

export const DatePickerContainer = styled.div`
  width: 300px;
  display: flex;
  padding-right: 10px;

  .ant-calendar-picker-input.ant-input {
    line-height: 1;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;

export const Content = styled.div`
  width: 2550px;
  min-height: 300px;
`;

export const BoxContentHeader = styled.div`
  margin-top: 20px;
  padding: 10px 30px;
  height: 30px;

  display: grid;
  grid-template-columns: 340px 110px 110px 210px 250px 200px 150px 980px;
  gap: 15px;

  svg {
    color: #dddbdb;
  }

  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 0.01px;
    color: #727272;
  }
`;

export const ContentItem = styled.div`
  padding: 10px 30px;

  min-height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-top: 15px;
  color: #235f6e;

  display: grid;
  grid-template-columns: 340px 110px 110px 210px 250px 200px 150px 980px;
  gap: 15px;
  align-items: center;

  div.itemDetails {
    word-break: break-word;
    span {
      font-size: 12px;
      line-height: 22px;
      color: #444;
      word-break: break-word;
    }
  }
`;
